import storage from 'utils/storage';

import { MAB_AUTH_TOKEN } from 'utils/constants';

export default {
  getAuthToken: () => storage.getItem(MAB_AUTH_TOKEN),
  setAuthToken: (authToken) => storage.setItem(MAB_AUTH_TOKEN, authToken),
  clearAuthToken: () => storage.remove(MAB_AUTH_TOKEN),
};